import './App.css';
import CSV from './CSVComponent';

function App() {
  return (
    <CSV />
  );
}

export default App;
